(() => {
  const searchPanel = () => document.querySelector('[data-header-search]');
  const filterPanel = () => document.querySelector('[data-filter-panel]');

  const closeSearch = () => {
    if (!searchPanel()?.classList.contains('is-open')) return;
    document.querySelector('[data-header-search-close]')?.click();
  };

  const closeFilter = () => {
    if (!filterPanel()?.classList.contains('is-open')) return;
    document.querySelector('[data-filter-collapse]')?.click();
  };

  const closeDrawers = () => {
    document.querySelectorAll('#CartDrawer.is-open,[data-mobile-menu].is-open').forEach((drawer) => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    });
    document.documentElement.classList.remove('is-locked');
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-open],[data-mobile-menu-open]')) {
      closeSearch();
      closeFilter();
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
      closeDrawers();
      closeFilter();
    }
  }, true);
})();
